<template>
    <div class="flex justify-content-between layout-topbar sm:py-8">
        <AppMenu class="w-1"/>
        <div class="flex justify-content-center spaced-4rem">
            <span class="sm:text-4xl md:text-5xl font-bold uppercase">{{ route.meta.title }}</span>
        </div>
        <div class="flex justify-content-center spaced-4rem w-1 mt-8 mr-4">
            <span class="sm:text-4xl md:text-5xl font-bold">{{ time }}</span>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import AppMenu from './AppMenu.vue';
import { getCurrentTime } from './utils/helpers';
import { useRoute } from 'vue-router';

const time = ref();
const route = useRoute();

onMounted(() => {
    time.value = getCurrentTime();
    setInterval(() => time.value = getCurrentTime(), 1000);
})
</script>